import { UserRole } from '../enums/common-enum';

export function isClientRole(roleId: number | null | undefined): boolean {
  return roleId === UserRole.Client;
}

export function isAdminRole(roleId: number | null | undefined): boolean {
  return roleId === UserRole.CremelloAdmin;
}
